import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { ApiKey } from '../api-key';
import { messages } from './messages';
import style from './style.module.less';

/**
 * This component renders the section to list and create API keys from V2
 * @param {object} props
 * @param {boolean} props.generateButtonDisabled - Disable the Generate API Key button
 * @param {import('ui-components/components/button').ButtonClickHandler} [props.onGenerateClick] - Callback when the user clicks the Generate button
 * @param {import('ui-components/components/button').ButtonClickHandler} [props.onDeleteClick] - Callback when the user clicks the Delete button
 * @param {import('../../types/api-keys').APIKeysV2} [props.v2ProductionApiKey]
 * @param {boolean} props.isCreatingApiKeys
 * @param {boolean} props.isRemovingApiKey
 * @returns {JSX.Element} The rendered component.
 */
export const ApiKeysV2 = ({
  generateButtonDisabled,
  onGenerateClick,
  onDeleteClick,
  v2ProductionApiKey,
  isCreatingApiKeys,
  isRemovingApiKey,
}) => {
  const intl = useIntl();

  return (
    <section className={style['settings-api-key-v2-wrapper']}>
      {v2ProductionApiKey ? (
        <ApiKey
          onDelete={onDeleteClick}
          removeButtonDisabled={isRemovingApiKey}
          title={intl.formatMessage(messages.productionKey)}
          value={v2ProductionApiKey.encryptedApiKey}
        />
      ) : null}

      {!v2ProductionApiKey && (
        <div className={style['settings-api-key-empty']}>
          <Text textType={TextType.H4} value={messages.productionKey} />

          <Button disabled={generateButtonDisabled} onClick={onGenerateClick} theme='primary'>
            {isCreatingApiKeys ? <FormattedMessage {...messages.generatingApiKey} /> : <FormattedMessage {...messages.generateApiKey} />}
          </Button>
        </div>
      )}
    </section>
  );
};
